import { useTranslation } from 'react-i18next';
import { HOT_KEY_LABEL_TOGGLE_CAMERA, Icon } from '@web-chat-core/ui-kit';
import { useUserSettingsContext } from 'contexts';
import { ObstacleIds } from 'features/MutedSpeechDetection/guardController';
import { ControlButton } from '../ControlButton/ControlButton';
import { MenuItem } from '../ControlButtonMenu/ControlButtonMenu';
import { VideoOffIcon } from './view';
import { buildMenu } from './helper';

export interface VideoButtonProps {
    onClick?: () => void;
    onSourceSelected?: (device: MediaDeviceInfo) => void;
    disableText?: string;
    enableText?: string;
    isButtonDisabled?: boolean;
    isAdvancedSoundAndCameraSettingsEnabled?: boolean;
    tooltipTitle?: string;
}

export const VideoButton = ({
    onClick,
    onSourceSelected,
    isButtonDisabled,
    isAdvancedSoundAndCameraSettingsEnabled = false,
    tooltipTitle,
}: VideoButtonProps) => {
    const { t } = useTranslation();
    const { videoEnabled, videoDevices, videoDeviceId, permissions } = useUserSettingsContext();

    const menuItems = buildMenu({
        isAdvanced: isAdvancedSoundAndCameraSettingsEnabled,
        videoDevices,
        videoDeviceId,
    });

    const handleMenuItem = (item: MenuItem) => {
        const device = videoDevices.find((d) => d.label === item.text);
        if (device && onSourceSelected) {
            onSourceSelected(device);
        }
    };

    const toggleCameraText = t(videoEnabled ? 'web_call_camera_turn_off' : 'web_call_camera_turn_on');
    const title =
        tooltipTitle ??
        (permissions.video ? `${toggleCameraText} (${HOT_KEY_LABEL_TOGGLE_CAMERA})` : t('web_call_access_camera_site'));

    return (
        <ControlButton
            menuId={ObstacleIds.ControlVideoMenu}
            active={videoEnabled}
            title={title}
            disabled={isButtonDisabled}
            onClick={onClick}
            menuItems={menuItems}
            onMenuItemClick={handleMenuItem}
            withoutMenuShadow
        >
            {videoEnabled ? (
                <Icon icon="icVideoOnCallFilled" colorVariant="bright" />
            ) : (
                <VideoOffIcon icon="icVideoOffCallFilled" />
            )}
        </ControlButton>
    );
};
